import { createSelector } from 'reselect'

export const getPackageCategories = createSelector(
  state => state && state.user && state.user.packages && state.user.packages.packageCategories
    ? state.user.packages.packageCategories.items : [],
  items => {
    return items.filter(item => item.category && item.category.online)
  }
)
